import { render, staticRenderFns } from "./paymentsReceivedMonthlyChartWidget.vue?vue&type=template&id=731c4d7e&"
import script from "./paymentsReceivedMonthlyChartWidget.vue?vue&type=script&lang=js&"
export * from "./paymentsReceivedMonthlyChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports